// extracted by mini-css-extract-plugin
module.exports = {"shareBar":"shareBar-module--shareBar--3arpf","button":"shareBar-module--button--2G-sc"};